import { call, put, takeLatest } from 'redux-saga/effects';
import { LibraryActionTypes } from './libraryTypes';
import { libraryApiResponseSuccess, libraryApiResponseError } from './libraryActions';
import { getInsightsApi, deleteInsightApi } from '../api/distillNode';

function* fetchInsightsSaga(action: any): any {
  try {
    const response = yield call(getInsightsApi, action.payload.page);
    const data = response.data ?? response;
    yield put(libraryApiResponseSuccess(LibraryActionTypes.FETCH_INSIGHTS, data));
  } catch (error: any) {
    yield put(
      libraryApiResponseError(
        LibraryActionTypes.FETCH_INSIGHTS,
        error?.response?.data?.error || error?.message || 'Failed to load library',
      ),
    );
  }
}

function* deleteInsightSaga(action: any): any {
  try {
    const response = yield call(deleteInsightApi, action.payload.id);
    const data = response.data ?? response;
    yield put(libraryApiResponseSuccess(LibraryActionTypes.DELETE_INSIGHT, { id: action.payload.id }));
  } catch (error: any) {
    yield put(
      libraryApiResponseError(
        LibraryActionTypes.DELETE_INSIGHT,
        error?.response?.data?.error || error?.message || 'Delete failed',
      ),
    );
  }
}

export default function* librarySaga() {
  yield takeLatest(LibraryActionTypes.FETCH_INSIGHTS, fetchInsightsSaga);
  yield takeLatest(LibraryActionTypes.DELETE_INSIGHT, deleteInsightSaga);
}
